<template>
  <v-app>
    <div>

      <b-form @submit.stop.prevent="formOnsubmit">

        <div class="lookup-panel">
          <label class="font-weight-bold">Pasien penerima (disarankan)</label>
          <div class="patient-picker-row">
            <div><strong>{{ selectedPatientName || 'Belum memilih pasien' }}</strong><small>{{ selectedPatientName ? 'Identitas pasien terhubung ke transaksi ini.' : 'Pilih pasien klinik, atau isi manual untuk penerima eksternal.' }}</small></div>
            <b-button type="button" variant="outline-primary" v-b-modal.modal-patient><i class="fas fa-search mr-2"></i>Pilih pasien</b-button>
          </div>
        </div>

        <!-- Input Name -->
        <b-form-group
          id="input-group-name"
          label="Nama Penerima Donor:"
          label-for="input-name"
        >
          <b-form-input
            id="input-name"
            v-model="form.name"
            placeholder="Nama Penerima Donor"
          >
          </b-form-input>
          <small class="text-danger">{{ error.name }}</small>
        </b-form-group>

        <!-- Input Email -->
        <b-form-group
          id="input-group-email"
          label="Email Penerima:"
          label-for="input-email"
        >
          <b-form-input
            id="input-email"
            v-model="form.email"
            placeholder="Email penerima (opsional)"
          >
          </b-form-input>
          <small class="text-danger">{{ error.email }}</small>
        </b-form-group>

        <!-- Input No KTP -->
        <b-form-group
          id="input-group-id-card-number"
          label="No. Identitas Penerima:"
          label-for="input-id-card-number"
        >
          <b-form-input
            id="input-id-card-number"
            v-model="form.id_card_number"
            placeholder="No. identitas penerima (opsional)"
          >
          </b-form-input>
          <small class="text-danger">{{ error.id_card_number }}</small>
        </b-form-group>

        <!-- Input BloodType -->
        <b-form-group
          id="input-group-blood-type"
          label="Golongan Darah:"
          label-for="input-blood-type"
        >
          <treeselect
            v-model="form.blood_type_id"
            :multiple="false"
            :options="blood_types"
          />
          <small class="text-danger">{{ error.blood_type }}</small>
        </b-form-group>

        <!-- Input Age -->
        <!-- <b-form-group
        id="input-group-age"
        label="Umur Pendonor:"
        label-for="input-age"
      >
        <b-form-input
          id="input-age"
          v-model="form.age"
          type="number"
          placeholder="Umur Pendonor"
        >
        </b-form-input>
        <small class="text-danger">{{ error.age }}</small>
      </b-form-group> -->

        <!-- Input Birt Date -->
        <b-form-group
          id="input-group-date"
          label="Tanggal Lahir:"
          label-for="input-date"
        >

          <v-dialog
            ref="dialog"
            v-model="modal_birt_date"
            :return-value.sync="form.birt_date"
            persistent
            width="350px"
          >
            <template v-slot:activator="{ on, attrs }">

              <b-form-input
                readonly
                v-bind="attrs"
                v-on="on"
                id="input-birt-date"
                v-model="form.birt_date"
              >
              </b-form-input>
            </template>

            <v-date-picker
              locale="id"
              v-if="modal_birt_date"
              v-model="form.birt_date"
              @input="setAge"
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="modal_birt_date = false"
              >
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.dialog.save(form.birt_date)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>

          <small class="text-danger">{{ error.date }}</small>
        </b-form-group>

        <!-- Input Last Donation Date -->
        <!-- <b-form-group
        id="input-group-last-donation-date"
        label="Tanggal Menerima Donor"
        label-for="input-last-donation-date"
      >
        <b-form-datepicker
          id="input-last-donation-date"
          v-model="form.receipt_date"
          placeholder="Tanggal Menerima Donor"
        ></b-form-datepicker>
        <small class="text-danger">{{ error.receipt_date }}</small>
      </b-form-group> -->
        <b-form-group
          id="input-group-date"
          label="Tanggal Darah Keluar:"
          label-for="input-date"
        >

          <v-dialog
            ref="dialog_donation"
            v-model="modal_last_donation_date"
            :return-value.sync="form.receipt_date"
            persistent
            width="350px"
          >
            <template v-slot:activator="{ on, attrs }">

              <b-form-input
                readonly
                v-bind="attrs"
                v-on="on"
                id="input-last-donation-date"
                v-model="form.receipt_date"
              >
              </b-form-input>
            </template>

            <v-date-picker
              v-if="modal_last_donation_date"
              v-model="form.receipt_date"
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="modal_last_donation_date = false"
              >
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.dialog_donation.save(form.receipt_date)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>

          <small class="text-danger">{{ error.date }}</small>
        </b-form-group>

        <!-- Input Phone -->
        <b-form-group
          id="input-group-phone"
          label="Nomor Handphone:"
          label-for="input-phone"
        >
          <b-form-input
            id="input-phone"
            v-model="form.phone"
            type="number"
            placeholder="Nomor Handphone"
          >
          </b-form-input>
          <small class="text-danger">{{ error.phone }}</small>
        </b-form-group>

        <!-- Input Gender -->
        <b-form-group
          id="input-group-gender"
          label="Jenis Kelamin:"
          label-for="input-gender"
        >
          <b-form-select
            id="input-gender"
            v-model="form.gender"
            :options="genders"
          ></b-form-select>
          <small class="text-danger">{{ error.gender }}</small>
        </b-form-group>

        <!-- Input Quantity -->
        <b-form-group
          id="input-group-quantity"
          label="Jumlah Kantong Darah:"
          label-for="input-quantity"
        >
          <b-form-input
            id="input-quantity"
            v-model="form.quantity"
            placeholder="Jumlah Kantong Darah"
          >
          </b-form-input>
          <small class="text-danger">{{ error.quantity }}</small>
        </b-form-group>

        <!-- Input Address -->
        <b-form-group
          id="input-group-address"
          label="Alamat:"
          label-for="input-address"
        >
          <b-form-textarea
            id="input-address"
            v-model="form.address"
            rows="3"
            placeholder="Alamat penerima"
          ></b-form-textarea>
          <small class="text-danger">{{ error.address }}</small>
        </b-form-group>

        <b-button
          type="submit"
          variant="primary"
        >Simpan</b-button>
        <b-button
          type="button"
          class="ml-2"
          variant="default"
          @click="$router.push('/donor-recipients/list')"
        >
          Batal
        </b-button>

      </b-form>

      <ModalPatient @chosenPatient="patientOnSelect" @submitedPatient="patientOnSelect" source="blood-bank" />

    </div>
  </v-app>
</template>

<script>
import module from '@/core/modules/CrudModule.js'
import validation from '@/core/modules/ValidationModule.js'
import ModalPatient from '@/component/general/ModalPatient.vue'
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {

  components: { ModalPatient },

  props: {
    form: Object,
    route: String
  },

  data() {
    return {
      error: {
        name: "",
        blood_type_id: null,
        age: null,
        birt_date: null,
        receipt_date: "",
        phone: "",
        gender: null,
        quantity: null,
        email: "",
        id_card_number: null,
        address: "",
      },
      modal_birt_date: false,
      modal_last_donation_date: false,
      blood_types: [],
      selectedPatientName: '',
      genders: [
        { text: "Pilih Jenis Kelamin", value: null, disabled: true },
        { text: 'Laki-laki', value: 'Laki-laki' },
        { text: 'Perempuan', value: 'Perempuan' }
      ],
    }
  },

  methods: {

    async getBloodTypeOption() {
      let response = await module.setTreeSelect("blood-types");
      // Success
      if (response.state == "success") {
        // Set Option Select
        this.blood_types = response.data;
      }
    },

    patientOnSelect(patient) {
      this.form.patient_id = patient.id
      this.selectedPatientName = `${patient.name}${patient.patient_id ? ` (${patient.patient_id})` : ''}`
      this.form.name = patient.name || ''
      this.form.email = patient.email || ''
      this.form.id_card_number = patient.id_card_number || ''
      this.form.birt_date = patient.birt_date || null
      this.form.phone = patient.mobile_phone || patient.phone || ''
      this.form.gender = patient.gender || null
      this.form.address = patient.address || ''
      if (this.form.birt_date) this.setAge(this.form.birt_date)
      const bloodType = (this.blood_types || []).find(type => type.label === patient.blood_type)
      if (bloodType) this.form.blood_type_id = bloodType.id
    },

    setAge(evt) {

      var today = new Date();
      var birthDate = new Date(evt);
      var age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      this.form.age = age;
    },

    getAge(today) {

      var today = new Date();
      var birthDate = new Date(today);
      var age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      this.form.age = age;
    },

    async formOnsubmit() {
      // Make Request
      let response = await module.submitDonor(this.form, this.route)
      // Check Response
      if (response.state == 'error') {
        // Validation Error
        this.error = validation.setValidationError(this.error, response.error.errors)
      } else {
        // Success
        if (response.success.item.original == null) {
          Swal.fire(response.success.title, response.success.message, 'error')
          this.error.quantity = "Stok golongan darah yang dibutuhkan tidak mencukupi"
        } else {
          Swal.fire(response.success.title, response.success.message, 'success')
          this.$router.push('/donor-recipients')
        }
      }
    }

  },

  mounted() {
    this.getBloodTypeOption()
    this.getAge(window.medhopToday())
  }

}
</script>

<style scoped>
.lookup-panel{margin-bottom:18px;padding:14px 16px;border:1px solid #bfdbfe;border-radius:12px;background:#f8fbff}.patient-picker-row{display:flex;align-items:center;justify-content:space-between;gap:16px}.patient-picker-row strong,.patient-picker-row small{display:block}.patient-picker-row small{margin-top:3px;color:#64748b}@media(max-width:575px){.patient-picker-row{align-items:stretch;flex-direction:column}}
</style>
